import { IViewNavigator } from '@dirootie-web/web-apps-types';
import { useContainer } from './use-container.hook';

export const useNavigation = () => {
  const container = useContainer();
  const navigator = container.resolve<IViewNavigator>('navigator');
  return navigator;
};
